import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import MainProductScene from "entities/configurator/product-scene";
import ArrowNext from "entities/configurator/standard-product-scene-carousel/components/ArrowNext";
import { Suspense, useEffect, useRef } from "react";
import Slider from "react-slick";
import OptionConfigurationImage from "shared/ui/option-configuration-image";
import { twMerge } from "tailwind-merge";
import ArrowPrevious from "widgets/shared/carousel/components/ArrowPrevious";
import "./dots.css";

export const MobileConfiguratorProductScene = () => {
  const {
    selectedDoor,
    layout,
    eigenwijs_layout,
    color,
    glass,
    handle,
    extra,
  } = useConfigurationOptionsContext();
  const sliderRef = useRef<Slider>(null);

  // Get the selected door name
  const doorName = selectedDoor?.name ?? "";

  // By default most of the doors have the carousel images
  let sliderImages = selectedDoor?.carrouselImageIds ?? [];

  // If its an extrawidth, XL-XXL door, change the carousel images
  if (/X+L/.test(doorName) && extra && extra.length > 0) {
    const option = extra.find((e) => e.code.includes("breedte"));
    sliderImages = option?.carrouselImageIds ?? [];
  }

  useEffect(() => {
    const goToFirstSlide = () => {
      if (sliderRef && sliderRef.current) {
        sliderRef.current.slickGoTo(0);
      }
    };

    const timer = setTimeout(goToFirstSlide, 100);

    return () => clearTimeout(timer);
  }, [layout, eigenwijs_layout, color, glass, handle]);

  const settings = {
    customPaging: function (i: number) {
      return (
        <div className="gg-aspect-square gg-w-2 gg-rounded-full gg-bg-[#d7d7da]"></div>
      );
    },
    // *Hide thumbnail dots on mobile screen
    // *Show on bigger screens
    dots: true,
    dotsClass:
      "-gg-mt-0.5 gg-h-15  gg-justify-center gg-pt-2  gg-gap-3 gg-flex custom-dots ",
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,

    // Custom arrows
    nextArrow: <ArrowNext />,
    prevArrow: <ArrowPrevious />,
  };

  // Slide show
  // Mobile hide
  // Rest sizes: render images
  const sliderSlideshow =
    sliderImages.length > 0 &&
    sliderImages.slice(0, 4).map(
      (imageId) =>
        imageId.length !== 0 && (
          <div
            className="gg-h-64 gg-w-full"
            // className="gg-mt-[8.5dvh] sm:gg-mt-[6dvh] gg-w-full gg-aspect-video"
            key={imageId}
          >
            <OptionConfigurationImage
              key={imageId}
              imageId={imageId}
              className="gg-h-full gg-w-full gg-object-cover gg-object-center gg-pb-2"
            />
          </div>
        ),
    );
  return (
    <Suspense fallback={null}>
      <div className="slider-container gg-mx-auto gg-mt-4 gg-w-[70%]">
        <Slider ref={sliderRef} {...settings}>
          {/* Door configurator canvas */}
          <MainProductScene doorClassName="gg-h-64 gg-col-span-full gg-w-full " />

          {/* Selected door images */}
          {sliderSlideshow}
        </Slider>
      </div>
    </Suspense>
  );
};
